export default "__VITE_ASSET__BdDHewOB__"